export default __webpack_public_path__ + "assets/models/b97a6152c0c64ba5ac2f4ebe0b59d3dd.glb";